import { Types } from '../../constants';
import { Helper } from '../Helper';
export class SetArrayStorageHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.getArrayStorageLength);
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'PICK');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'LTE');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DUP');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'INC');
                sb.emitHelper(node, options, sb.helpers.putArrayStorageLength);
            },
        }));
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.wrapNumber);
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.setStructuredStorage({ type: Types.ArrayStorage, keyType: undefined, knownKeyType: Types.Number }));
    }
}

//# sourceMappingURL=SetArrayStorageHelper.js.map
